/**
 * Şablon sütunu (#298) — kullanıcı / çalışan listesini şablona göre sayar ve
 * süzer. Kullanıcılar `roleTemplate`, çalışanlar `employeeTemplate` taşır;
 * hangi alanın okunacağını `getTemplateId` söyler.
 *
 * Seçim değerleri:
 *   ALL_TEMPLATES  (null)   → süzme yok
 *   NO_TEMPLATE ("__none__") → şablonu olmayan ya da şablonu artık listede
 *                              olmayan (silinmiş) kişiler
 *   "<şablon id>"           → o şablondakiler
 */
export const ALL_TEMPLATES = null;
export const NO_TEMPLATE = "__none__";

const idOf = (v) => (v && typeof v === "object" ? String(v._id || "") : v ? String(v) : "");

/**
 * @returns {{ total: number, unassigned: number, counts: Object<string, number> }}
 */
export const countByTemplate = (items = [], templates = [], getTemplateId) => {
  const known = new Set(templates.map((t) => String(t._id)));
  const counts = {};
  templates.forEach((t) => {
    counts[String(t._id)] = 0;
  });
  let unassigned = 0;
  items.forEach((item) => {
    const id = idOf(getTemplateId(item));
    if (id && known.has(id)) counts[id] += 1;
    else unassigned += 1;
  });
  return { total: items.length, unassigned, counts };
};

/** Seçili şablona göre satır süzgeci; ALL_TEMPLATES'te her satır geçer. */
export const templateFilterFor = (selectedId, templates = [], getTemplateId) => {
  if (selectedId === ALL_TEMPLATES || selectedId === undefined) return () => true;
  if (selectedId === NO_TEMPLATE) {
    const known = new Set(templates.map((t) => String(t._id)));
    return (item) => {
      const id = idOf(getTemplateId(item));
      return !id || !known.has(id);
    };
  }
  return (item) => idOf(getTemplateId(item)) === String(selectedId);
};

/** Kullanıcı satırının şablonu. */
export const userTemplateId = (user) => user?.roleTemplate;
/** Çalışan satırının şablonu (sunucu `employeeTemplateInfo` da ekleyebilir). */
export const employeeTemplateId = (user) => user?.employeeTemplate || user?.employeeTemplateInfo?._id;
